import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

export interface IMarqueeProps {
  text: string;
  /**
   * @description Отступ по вертикали у текста бегущей строки
   * @example s - 8px, m - 16px
   */
  textPadding?:
    | 's' // 8px
    | 'm'; // 16px;
}

/* Компонент бегущей строки */
export function Marquee({ text, textPadding }: IMarqueeProps) {
  const textRef = React.useRef<HTMLDivElement>(null);

  const mouseOverHandler = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    /* istanbul ignore else */
    if (textRef.current) {
      const containerWidth = event.currentTarget.offsetWidth;
      const childWidth = textRef.current.offsetWidth;

      const diff = childWidth - containerWidth;

      if (diff > 0) {
        textRef.current.style.transition = `transform ${diff / 100}s linear`;
        textRef.current.style.transform = `translate(-${diff}px, 0)`;
      }
    }
  };

  const mouseLeaveHandler = () => {
    /* istanbul ignore else */
    if (textRef.current) {
      textRef.current.style.transform = '';
      textRef.current.style.transition = '';
    }
  };

  return (
    <div
      data-testid="marquee"
      className={styles['container']}
      onMouseOver={mouseOverHandler}
      onMouseLeave={mouseLeaveHandler}
    >
      <span
        ref={textRef}
        className={clsx(styles['text'], textPadding && styles[`text-padding-${textPadding}`])}
        data-testid="MarqueeText"
      >
        {text}
      </span>
    </div>
  );
}
